import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Archive, RotateCcw } from 'lucide-react';
import { projectImage, projectStatus, fmt } from '../../../lib/projectVisuals';

export const ProjectCard = ({ project, summary, onArchive, index }) => {
  const st = projectStatus(project);
  const changed = project.updated_at || project.created_at;
  return (
    <div className="op-card group overflow-hidden op-rise flex flex-col" style={{ animationDelay: `${Math.min(index, 8) * 40}ms` }} data-testid={`project-row-${project.id}`}>
      <Link to={`/dashboard/projects/${project.id}`} className="flex sm:flex-col gap-3 sm:gap-0 p-3 sm:p-0 flex-1" data-testid={`view-project-${project.id}`}>
        <div className="relative w-28 h-24 sm:w-full sm:h-40 flex-shrink-0 overflow-hidden rounded-xl sm:rounded-none">
          <img src={projectImage(project, summary)} alt="" loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent hidden sm:block" />
          <span className={`absolute top-2.5 right-2.5 hidden sm:inline-flex items-center gap-1 rounded-lg px-2 py-1 text-[10.5px] font-bold bg-white/95 ${st.cls.split(' ').filter((c) => c.startsWith('text-')).join(' ')}`}>
            <span className={`w-1.5 h-1.5 rounded-full ${st.dot}`} />{st.label}
          </span>
        </div>
        <div className="flex-1 min-w-0 sm:p-4">
          <div className="flex items-start justify-between gap-2">
            <div className="min-w-0">
              <h3 className="text-[15px] font-bold truncate">{project.name}</h3>
              <p className="text-xs text-stone-500 truncate">{project.location || project.customer || 'Ingen plats angiven'}</p>
            </div>
            <span className={`sm:hidden flex-shrink-0 rounded-md px-1.5 py-0.5 text-[10px] font-bold ${st.cls}`}>{st.label}</span>
          </div>
          <dl className="mt-3 grid grid-cols-[1fr_auto] gap-y-1 text-[11.5px]">
            <dt className="text-stone-500">Total yta</dt><dd className="text-right font-semibold op-num">{summary?.total_area_m2 ? `${fmt(summary.total_area_m2)} m²` : '—'}</dd>
            <dt className="text-stone-500">Beräknat materialvärde</dt><dd className="text-right font-semibold op-num">{summary?.total_estimated_cost ? `${fmt(summary.total_estimated_cost)} kr` : 'Ej beräknat'}</dd>
            <dt className="text-stone-500">Senast ändrad</dt><dd className="text-right text-stone-600">{changed ? new Date(changed).toLocaleDateString('sv-SE') : '—'}</dd>
          </dl>
        </div>
      </Link>
      <div className="flex items-center justify-between border-t border-stone-100 px-4 py-2.5">
        <button onClick={(e) => onArchive(project, e)} className="text-xs text-stone-500 hover:text-stone-900 inline-flex items-center gap-1.5" data-testid={`archive-project-${project.id}`}>
          {project.archived ? <><RotateCcw size={13} />Återställ</> : <><Archive size={13} />Arkivera</>}
        </button>
        <Link to={`/dashboard/projects/${project.id}`} className="text-xs font-semibold text-[#E05A10] inline-flex items-center gap-0.5" data-testid={`open-project-${project.id}`}>Öppna<ChevronRight size={14} /></Link>
      </div>
    </div>
  );
};
